var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.591 6.45316V6.65316H12.791H14.6983H14.8983V6.45316C14.8983 3.38094 12.2339 0.913281 8.97662 0.913281C5.71929 0.913281 3.05496 3.38094 3.05496 6.45316V6.65316H3.25496H5.16215H5.36215L5.36215 6.45316C5.36213 4.61027 6.96725 3.09321 8.97662 3.09321C10.9859 3.09321 12.591 4.61027 12.591 6.45316ZM9.10147 10.4103L9.09968 10.4067H8.97662C7.82577 10.4067 6.86934 11.2802 6.86934 12.3868C6.86934 13.0842 7.25627 13.6851 7.82305 14.0349V15.6133C7.82305 16.2406 8.34504 16.7402 8.97669 16.7402C9.60813 16.7402 10.1303 16.2406 10.1303 15.6133V14.0349C10.697 13.6851 11.0839 13.0842 11.0839 12.3868V12.3867C11.0838 11.3205 10.1958 10.4707 9.10147 10.4103ZM15.3341 7.44022H2.61923C1.81973 7.44022 1.14766 8.04834 1.14766 8.82667V17.7267C1.14766 18.5055 1.81964 19.1137 2.61923 19.1137H15.3341H15.3342C16.1335 19.1138 16.8056 18.5055 16.8056 17.7267V8.82664C16.8056 8.04833 16.1334 7.44022 15.3341 7.44022ZM15.3422 17.7543C15.3422 17.7788 15.3213 17.7997 15.2967 17.7997H2.71682C2.69226 17.7997 2.67139 17.7788 2.67139 17.7543V8.97937C2.67139 8.95479 2.69228 8.93392 2.71682 8.93392H15.2967C15.3213 8.93392 15.3422 8.95488 15.3422 8.97937V17.7543Z",
    fill: "#D95204",
    stroke: "#D95204",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPermission);
export default __webpack_public_path__ + "static/media/user-permission.c86babf13a989bb870d75d65e55acd92.svg";
export { ForwardRef as ReactComponent };